import { render, staticRenderFns } from "./ArrowDownIcon.vue?vue&type=template&id=4bb5e9f0&scoped=true&"
import script from "./ArrowDownIcon.vue?vue&type=script&lang=ts&"
export * from "./ArrowDownIcon.vue?vue&type=script&lang=ts&"
import style0 from "./ArrowDownIcon.vue?vue&type=style&index=0&id=4bb5e9f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bb5e9f0",
  null
  
)

export default component.exports